import * as React from 'react'
import { MultiSelectFilter } from '@user/components/Filters'
import { PostalCodeProvider } from './PostalCodeProvider'
import { useTranslation } from 'react-i18next'

export const LocationFilters: React.FC = () => {
  const { t } = useTranslation()
  return (
    <>
      <MultiSelectFilter
        name="postalCode"
        label={t('postalCode')}
        component={PostalCodeProvider}
      />
    </>
  )
}
LocationFilters.displayName = 'LocationFilters'
